import React, { memo } from "react";
import { View } from "react-native";
import StatsCard, { type IconProps } from "./stats-card";

type StatItem = Readonly<{
  count: number;
  text: string;
  icon: React.ReactElement<IconProps>;
}>;

type StatsRowProps = Readonly<{
  stats: ReadonlyArray<StatItem>;
}>;

const StatsRow = ({ stats }: StatsRowProps) => {
  return (
    // No `md:flex-1` here, deliberately.
    // Both consumers put this in a column parent.
    // That column grows to the viewport height.
    // So flex-1 grew this panel vertically, not sideways.
    // It was the column's only growable child.
    // It therefore absorbed every pixel of leftover height.
    // A short loading state left plenty of it.
    // The cards stretched too, since flex rows stretch children.
    // Width is unaffected — the column already stretches this.
    <View className="flex-row justify-center gap-2 flex-wrap md:flex-nowrap md:rounded-2xl md:border md:border-ash-3 bg-chalk md:p-6">
      {stats.map((statItem) => (
        <StatsCard
          key={statItem.text}
          count={statItem.count}
          text={statItem.text}
          icon={statItem.icon}
        />
      ))}
    </View>
  );
};

export default memo(StatsRow);
